// extracted by mini-css-extract-plugin
export var errorsContainer = "_t8-1";
export var link = "_t8-0";